import { APIMethod, fetchData } from "@client";

export async function saveTemplateQuery(
  id,
  {
    name,
    description,
    types,
    color,
  },
) {
  await fetchData(`/template/${id}`, APIMethod.POST, {
    data: {
      name,
      description,
      color,
      labels: types ? JSON.stringify(types) : undefined,
    },
    removeEmptyKeys: true,
  });
}
